import { FC } from "react";
import { Grid, FormSection } from "@monolith-forensics/monolith-ui";
import CustomFieldRender from "@/components/Forms/components/CustomFieldRender";
import { useCustomFields, CustomField } from "./hooks/useCustomFields";
import { UseFormReturnType } from "@mantine/form";
import { EvidenceFormData } from "../evidence.types";

interface EvidenceCustomFieldsFormProps {
  form: UseFormReturnType<EvidenceFormData>; // Form instance from @mantine/form
  itemType?: number | null; // Selected evidence type ID for filtering
  defaultOpen?: boolean; // Whether the section should be open by default
  title?: string; // Custom title for the section
}

const EvidenceCustomFieldsForm: FC<EvidenceCustomFieldsFormProps> = ({
  form,
  itemType,
  defaultOpen = false,
  title = "Custom Fields",
}) => {
  // Fetch custom fields for evidence
  const {
    data: customFields,
    isFetched: customFieldsFetched,
    error,
  } = useCustomFields();

  // Handle loading state
  if (!customFieldsFetched) {
    return <div>Loading custom fields...</div>;
  }

  // Handle error state
  if (error) {
    return null;
  }

  // Handle no custom fields available
  if (!customFields || customFields.length === 0) {
    return null;
  }

  const filteredCustomFields = customFields.filter(
    (field: CustomField) =>
      !field?.type_ids?.length || // covers null, undefined, and []
      (itemType && field?.type_ids?.includes?.(itemType))
  );

  // Don't render if no custom fields match the filter
  if (filteredCustomFields.length === 0) {
    return null;
  }

  return (
    <FormSection
      title={title}
      defaultOpen={defaultOpen}
      style={{ marginTop: 15 }}
    >
      <Grid col={2}>
        {filteredCustomFields.map((field: CustomField) => {
          const fieldKey = `custom_attribute_${field.field_id}`;
          return (
            <CustomFieldRender
              key={form.key(fieldKey)}
              field={field}
              inputProps={form.getInputProps(fieldKey)}
              onChange={() => {}}
            />
          );
        })}
      </Grid>
    </FormSection>
  );
};

export default EvidenceCustomFieldsForm;
